import { render, staticRenderFns } from "./CreditSales.vue?vue&type=template&id=fe8ff950"
import script from "./CreditSales.vue?vue&type=script&lang=js"
export * from "./CreditSales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports